import {iCoreSignalBusinessLinkedIn} from 'app/hooks/external/useMockLinkedInBusinessCoreSignal'
import {MPersonDetailGraphEntity} from 'app/modules/discovery/core/_models'
import dayjs from 'dayjs'
import {IConceptFE} from 'interfaces/IConceptFE'
import {IBrightDataProfile} from 'interfaces/profile/IBrightDataProfile'
import {IResumeRChilli} from 'interfaces/profile/IResumeRChilli'
import uuid from 'react-uuid'

export function emRemoveEmpty(obj: any) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null))
}

export function emAddCommasToNumber(num: number | string): string {
  if (typeof num === 'number') {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else if (typeof num === 'string') {
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    console.warn('emAddCommasToNumber: input is not a number or string', num)
    return ''
  }
}

export function emGetInitials(inputString?: string | null, limit?: number): string {
  if (inputString)
    try {
      // Clean up punctuation in the input string
      inputString = (inputString || '').replace(/[^a-zA-Z ]/g, '')

      // Split the input string into an array of words
      const words = inputString.split(' ').filter((x) => x)

      // Initialize an empty string for storing the initials
      let initials = ''

      // Iterate through each word in the array
      for (let i = 0; i < words.length; i++) {
        // Get the first letter of the current word and make it uppercase
        const initial = words[i][0].toUpperCase()
        // Add the initial to the initials string
        initials += initial
      }
      if (limit && initials.length > limit) {
        initials = initials.substring(0, limit)
      }

      // Return the initials
      return initials
    } catch (error) {
      console.warn('getInitials error: ', error)
      return ''
    }
  return ''
}

export function emToTitleCase(str: string) {
  return str.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  )
}

export function emFormatLinkedInBusinessEntityData(res: iCoreSignalBusinessLinkedIn) {
  //try to get a location from company_location_collection
  const locPrimary = {street1: '', street2: '', city: '', state: '', country: '', zip: ''}
  const locSecondary = {
    street1: '',
    street2: '',
    city: '',
    state: '',
    country: '',
    zip: '',
  }
  const locationsTry = res.company_locations_collection
    ?.filter((c) => c.deleted === 0)
    ?.map((l) => l)
  if (locationsTry?.length) {
    locationsTry.map((m) => {
      if (m.is_primary === 1) {
        const parseOut = m.location_address.split(';')
        //check length for 2 or 3
        if (parseOut?.length) {
          //only one street
          if (parseOut.length === 2) {
            locPrimary.street1 = parseOut[0].trim()
            const parseAgain = parseOut[1].split(',')
            if (parseAgain.length) {
              if (parseAgain.length === 3) {
                //set city
                locPrimary.city = parseAgain[0].trim()
                if (parseAgain[1].includes(' ')) {
                  const splitStateZip = parseAgain[1].trim().split(' ')
                  if (splitStateZip.length === 2) {
                    locPrimary.state = splitStateZip[0].trim()
                    locPrimary.zip = splitStateZip[1].trim()
                  }
                }
                locPrimary.country = parseAgain[2].trim()
              }
            }
          }
          //possible second street
          if (parseOut.length === 3) {
            locPrimary.street1 = parseOut[0].trim()
            locPrimary.street2 = parseOut[1].trim()
            const parseAgain = parseOut[2].split(',')
            if (parseAgain.length) {
              if (parseAgain.length === 3) {
                //set city
                locPrimary.city = parseAgain[0].trim()
                if (parseAgain[1].includes(' ')) {
                  const splitStateZip = parseAgain[1].trim().split(' ')
                  if (splitStateZip.length === 2) {
                    locPrimary.state = splitStateZip[0].trim()
                    locPrimary.zip = splitStateZip[1].trim()
                  }
                }
                locPrimary.country = parseAgain[2].trim()
              }
            }
          }
        }
      } else {
        const parseOut = m.location_address.split(';')
        //check length for 2 or 3
        if (parseOut?.length) {
          //only one street
          if (parseOut.length === 2) {
            locSecondary.street1 = parseOut[0].trim()
            const parseAgain = parseOut[1].split(',')
            if (parseAgain.length) {
              if (parseAgain.length === 3) {
                //set city
                locSecondary.city = parseAgain[0].trim()
                if (parseAgain[1].includes(' ')) {
                  const splitStateZip = parseAgain[1].trim().split(' ')
                  if (splitStateZip.length === 2) {
                    locSecondary.state = splitStateZip[0].trim()
                    locSecondary.zip = splitStateZip[1].trim()
                  }
                }
                locSecondary.country = parseAgain[2].trim()
              }
            }
          }
          //possible second street
          if (parseOut.length === 3) {
            locSecondary.street1 = parseOut[0].trim()
            locSecondary.street2 = parseOut[1].trim()
            const parseAgain = parseOut[2].split(',')
            if (parseAgain.length) {
              if (parseAgain.length === 3) {
                //set city
                locSecondary.city = parseAgain[0].trim()
                if (parseAgain[1].includes(' ')) {
                  const splitStateZip = parseAgain[1].trim().split(' ')
                  if (splitStateZip.length === 2) {
                    locSecondary.state = splitStateZip[0].trim()
                    locSecondary.zip = splitStateZip[1].trim()
                  }
                }
                locSecondary.country = parseAgain[2].trim()
              }
            }
          }
        }
      }
    })
  }
  const entityData = {
    name: res.name,
    website: res.website,
    description: res.description,
    logo: res.logo_url,
    mailing_address_line_1: locSecondary.street1 ?? '',
    mailing_address_city: locSecondary.city ?? '',
    mailing_address_state_province: locSecondary.state ?? '',
    mailing_address_country: locSecondary.country ?? '',
    mailing_address_postal_code: locSecondary.zip ?? '',
    address_city: res.headquarters_city
      ? res.headquarters_city
      : locPrimary.city
      ? locPrimary.city
      : '',
    address_state_province: res.headquarters_state
      ? res.headquarters_state
      : locPrimary.state
      ? locPrimary.state
      : '',
    address_country: res.headquarters_country
      ? res.headquarters_country
      : res.headquarters_country_parsed
      ? res.headquarters_country_parsed
      : locPrimary.country
      ? locPrimary.country
      : '',
    address_line_1: res.headquarters_street1
      ? res.headquarters_street1
      : locPrimary.street1
      ? locPrimary.street1
      : '',
    address_line_2: res.headquarters_street2
      ? res.headquarters_street2
      : locPrimary.street2
      ? locPrimary.street2
      : '',
    address_postal_code: res.headquarters_zip
      ? res.headquarters_zip
      : locPrimary.zip
      ? locPrimary.zip
      : '',
    country: res.headquarters_country
      ? res.headquarters_country
      : res.headquarters_country_parsed
      ? res.headquarters_country_parsed
      : locPrimary.country
      ? locPrimary.country
      : '',
    city: res.headquarters_city ? res.headquarters_city : locPrimary.city ? locPrimary.city : '',
    state_province: res.headquarters_state
      ? res.headquarters_state
      : locPrimary.state
      ? locPrimary.state
      : '',
    linkedin_page: res.url,
    linkedin_key_data: {
      employee_urls: res.company_featured_employees_collection
        ?.filter((c) => c.deleted === 0)
        ?.map((c) => c.url),
      investor_list: res.company_featured_investors_collection
        ?.filter((c) => c.deleted === 0)
        ?.map((c) => {
          return {
            cb_url: c.company_investors_list?.cb_url || '',
            name: c.company_investors_list?.name || '',
          }
        }),
      funding_rounds: res.company_funding_rounds_collection
        ?.filter((f) => f.deleted === 0)
        ?.map((f) => {
          return {
            cb_url: f.cb_url,
            round_date: f.last_round_date,
            round_investor_count: f.last_round_investors_count,
            round_money_raised: f.last_round_money_raised,
            round_type: f.last_round_type,
            total_rounds_count: f.total_rounds_count,
          }
        }),
      industry: res.industry,
      size: res.size,
      type: res.type,
      founded: res.founded,
      employees_count: res.employees_count,
      specialties: res.company_specialties_collection
        ?.filter((c) => c.deleted === 0)
        ?.map((c) => c.specialty),
    },
    additionalInfo: [
      {
        source: 'linkedin',
        createdDtTm: new Date().toLocaleDateString(),
        data: res,
      },
    ],
  }
  return entityData
}

export function emInstanceOf<T>(object: any, fieldToCheck: any): object is T {
  return fieldToCheck in object
}

const sleep = (delayMilliseconds: number) =>
  new Promise((resolve: any) => setTimeout(resolve, delayMilliseconds))
export const emSleep = async (delayMilliseconds: number) => {
  await sleep(delayMilliseconds)
}

export const emToAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export type emRequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<
  T,
  Exclude<keyof T, Keys>
> &
  {
    [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>
  }[Keys]

export function emHasAllProperties(obj: any, props: any) {
  for (let i = 0; i < props.length; i++) {
    if (!(props[i] in obj)) return false
  }
  return true
}

export function emHasAnyProperties(obj: any, props: any) {
  for (let i = 0; i < props.length; i++) {
    if (props[i] in obj) return true
  }
  return false
}

export const emReorderConcepts = (list: IConceptFE[]) => {
  const result = list.sort((a, b) =>
    (a.name?.toLowerCase() || '').localeCompare(b.name?.toLowerCase() || '')
  )
  const secondSort = result.sort(function (a, b) {
    if ((a.__weight ?? 0) > (b.__weight ?? 0)) {
      return -1
    }
    if ((a.__weight ?? 0) < (b.__weight ?? 0)) {
      return 1
    }
    return 0
  })
  return secondSort
}

export const emArraySortByDateField = (arr: any, sortBy: string, nullFirst?: boolean) => {
  if (nullFirst) {
    const distantFuture = new Date(8640000000000000)
    const sorted = arr.sort((a: any, b: any) => {
      const dateA = a[sortBy] ? new Date(a[sortBy]) : distantFuture
      const dateB = b[sortBy] ? new Date(b[sortBy]) : distantFuture
      return dateB.getTime() - dateA.getTime()
    })
    return sorted
  }
  const retval = arr.sort((a: any, b: any) => Date.parse(a[sortBy]) - Date.parse(b[sortBy]))
  return retval
}

export const emGetwebsite_with_protocol = (website?: string | null): string => {
  if (website) {
    if (website.startsWith('http://') || website.startsWith('https://')) {
      return website
    }
    return `http://${website}`
  }
  return ''
}

export const emPercentProfileCompleted = (obj: any, total?: number) => {
  const num =
    (Object.entries(obj ?? {})?.filter(([k, v]) => Boolean(v))?.length ?? 0) /
    (total ? total : Object.keys(obj ?? {})?.length ?? 0)
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num)
}

export const emParseLocaleNumber = (stringNumber: string, locale = 'en') => {
  const thousandSeparator = Intl.NumberFormat(locale)
    .format(11111)
    .replace(/\p{Number}/gu, '')
  const decimalSeparator = Intl.NumberFormat(locale)
    .format(1.1)
    .replace(/\p{Number}/gu, '')

  return parseFloat(
    stringNumber
      .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + decimalSeparator), '.')
  )
}

export const emPercentageFormatter = (num: number) => {
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num)
}
export const emPercentageFormatterNumber = (dec: number) => {
  return new Intl.NumberFormat('default', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(dec)
}

export const emFormatToCurrency = (num: number) => {
  const formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})
  return formatter.format(num)
}

export const emFormatBrightDataProfileToPersonProfile = (
  data: IBrightDataProfile,
  person: MPersonDetailGraphEntity
) => {
  const nameSplit = data.name?.split(' ')
  let firstName = ''
  let midleName = ''
  let lastName = ''
  if (nameSplit?.length) {
    firstName = nameSplit[0]
    if (nameSplit.length > 2) {
      midleName = nameSplit.slice(1, -1).join(' ')
      lastName = nameSplit[nameSplit.length - 1]
    } else if (nameSplit.length === 2) {
      lastName = nameSplit[1]
    }
  } else {
    firstName = data.name ?? ''
    lastName = ''
  }

  const personProfile: MPersonDetailGraphEntity = {
    ...person,
    first_name: firstName,
    last_name: lastName,
    middle_name: midleName,
    headline: data.about,
    city: data.city,
    state: data.city,
    country: data.country_code,
    name: data.name,
    profile_picture_url: data?.avatar,
    social_media: {...person.social_media, linkedin: data.url},
    education: data.education?.map((e) => {
      let start = ''
      let end = ''
      if (e.start_year) {
        start = e.start_year
        if (start.length === 4) {
          start = '01/01/' + start
        }
      }
      if (e.end_year) {
        end = e.end_year
        if (end.length === 4) {
          end = '01/01/' + end
        }
      }
      return {
        id: uuid(),
        degree: e.degree,
        fieldOfStudy: e.field,
        beginDate: start ? `${dayjs(start).format('MM/DD/YYYY')}` : '',
        endDate: end ? `${dayjs(end).format('MM/DD/YYYY')}` : '',
        name: e.title,
        description: e.description,
        schoolLogoUrl: e.institute_logo_url,
        schoolUrl: e.url,
        completion: e.degree,
      }
    }),
    experience: data.experience?.map((e) => {
      let city = ''
      let state = ''
      let country = ''
      const splitLocation = e.location?.split(',')
      if (splitLocation?.length) {
        city = splitLocation[0]
        if (splitLocation.length > 2) {
          state = splitLocation.slice(1, -1).join(',')
          country = splitLocation[splitLocation.length - 1]
        } else if (splitLocation.length === 2) {
          state = splitLocation[1]
          country = ''
        }
      }
      if (splitLocation?.length === 1) {
        city = splitLocation[0]
        state = ''
        country = ''
      }

      let start = ''
      let end = ''
      if (e.start_date) {
        start = e.start_date
        if (start.length === 4) {
          start = '01/01/' + start
        }
      }
      if (e.end_date) {
        end = e.end_date
        if (end.length === 4) {
          end = '01/01/' + end
        }
      }
      return {
        id: uuid(),
        beginDate: start ? `${dayjs(start).format('MM/DD/YYYY')}` : '',
        endDate: end ? `${dayjs(end).format('MM/DD/YYYY')}` : '',
        name: e.title,
        description: e.description,
        companyUrl: e.url,
        title: e.title,
        companyName: e.company,
        location: e.location,
        city: city,
        state: state,
        country: country,
      }
    }),
  }

  Object.keys(personProfile).forEach((key) => {
    if (key.includes('__')) {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'brightdata_profile_parsed') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'owner') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'id') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'person_id') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'invited_owner') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'notes') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'entity_type') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
  })
  return personProfile
}

export const emFormatRChilliResumeProfileToPersonProfile = (
  data: IResumeRChilli,
  person: MPersonDetailGraphEntity
) => {
  const resume = data?.ResumeParserData
  const nameSplit = resume
  const firstName = resume?.Name?.FirstName
  const midleName = resume?.Name?.MiddleName
  const lastName = resume?.Name?.LastName

  const personProfile: MPersonDetailGraphEntity = {
    ...person,
    first_name: firstName,
    last_name: lastName,
    middle_name: midleName,
    phone_number: resume?.PhoneNumber?.map((p) => p.FormattedNumber).join(', '),
    description: resume?.Objectives ?? '',
    title: resume?.JobProfile,
    headline: resume?.JobProfile,
    city: resume?.Address?.length ? resume?.Address[0]?.City : '',
    state: resume?.Address?.length ? resume?.Address[0]?.State : '',
    country: resume?.Address?.length ? resume?.Address[0]?.Country : '',
    name: resume?.Name?.FullName,
    profile_picture_url: '',

    education: resume.SegregatedQualification?.map((e) => {
      let start = ''
      let end = ''
      if (e.StartDate) {
        start = e.StartDate
        if (start.length === 4) {
          start = '01/01/' + start
        }
      }
      if (e.EndDate) {
        end = e.EndDate
        if (end.length === 4) {
          end = '01/01/' + end
        }
      }
      return {
        id: uuid(),
        degree: e.Degree?.NormalizeDegree,
        fieldOfStudy: e.Degree?.Specialization?.map((f) => f).join(', '),
        beginDate: start ? `${dayjs(start, 'DD/MM/YY').format('MM/DD/YYYY')}` : '',
        endDate: end ? `${dayjs(end, 'DD/MM/YY').format('MM/DD/YYYY')}` : '',
        completion: e.Degree?.NormalizeDegree,
        attending: end ? false : true,
        name: e.Institution?.Name,
        description: e.Degree?.NormalizeDegree,
        city: e.Institution?.Location?.City,
        state: e.Institution?.Location?.State,
        country: e.Institution?.Location?.Country,
      }
    }),
    experience: resume.SegregatedExperience?.map((e) => {
      let city = ''
      let state = ''
      let country = ''
      if (e.Location) {
        city = e.Location?.City ?? ''
        state = e.Location?.State ?? ''
        country = e.Location?.Country ?? ''
      }

      let start = ''
      let end = ''
      if (e.StartDate) {
        start = e.StartDate
        if (start.length === 4) {
          start = '01/01/' + start
        }
      }
      if (e.EndDate) {
        end = e.EndDate
        if (end.length === 4) {
          end = '01/01/' + end
        }
      }
      return {
        id: uuid(),
        beginDate: start ? `${dayjs(start, 'DD/MM/YY').format('MM/DD/YYYY')}` : '',
        endDate: end ? `${dayjs(end, 'DD/MM/YY').format('MM/DD/YYYY')}` : '',
        name: e.Employer?.EmployerName,
        description: e.JobDescription,
        title: e.JobProfile.Title ?? e.JobProfile?.FormattedName ?? '',
        isCurrent: e.IsCurrentEmployer ?? 'false' === 'false' ? false : true,
        companyName: e.Employer?.EmployerName,
        location: city + ', ' + state + ', ' + country,
        city: e.Location?.City,
        state: e.Location?.State,
      }
    }),
  }
  Object.keys(personProfile).forEach((key) => {
    if (key.includes('__')) {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'rchilli_parsed_resume') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'owner') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'id') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'person_id') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'invited_owner') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'notes') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
    if (key === 'entity_type') {
      delete personProfile[key as keyof MPersonDetailGraphEntity]
    }
  })
  return personProfile
}
